import React, { memo } from 'react';
import { Empty } from 'antd';
import { DeleteModal } from './delete';
import { SalesManagerType } from '../index';
import { EditableInfoComponent } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { AddEditSalesManagerModal } from './addEdit';
import { SalesManagerCard } from './SalesManagerCard';
import { useSalesManagers } from './useSalesManagers';
import { ManagementIcon } from 'components/common/icons';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

interface ISalesManagers {
  salesManagers: SalesManagerType[];
}

export const SalesManagers = memo((props: ISalesManagers) => {
  const { salesManagers = [] } = props;
  const { hasAccess } = useAccessControl();
  const {
    onEditSalesManager,
    onHandleDelete,
    onSalesModalStateChange,
    salesManagerToEdit,
    isSalesModalOpen,
    deleteItemId,
    onDeleteModalClose,
  } = useSalesManagers();

  return (
    <>
      <EditableInfoComponent
        title={'Sales Managers'}
        icon={<ManagementIcon />}
        creatable={hasAccess(PERMISSIONS.brands.sales_management.write)}
        editable={false}
        onAdd={onSalesModalStateChange}
      />
      {salesManagers?.map((i: SalesManagerType, index: number) => (
        <SalesManagerCard
          onEdit={() => onEditSalesManager(i)}
          onDelete={() => onHandleDelete(i?.brandSalesManagerId)}
          key={index + i.salesManager?.id}
          data={i}
        />
      ))}
      {(!salesManagers || !salesManagers?.length) && <Empty style={{ marginTop: 50 }} />}
      <AddEditSalesManagerModal
        dataToEdit={salesManagerToEdit}
        openModal={isSalesModalOpen}
        onModalStateChange={onSalesModalStateChange}
      />
      <DeleteModal
        openModal={!!deleteItemId}
        onDeleteModalClose={onDeleteModalClose}
        dataToDelete={{ id: deleteItemId }}
      />
    </>
  );
});
